import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ProfileComponent } from './components/profile/profile.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UserService } from './shared/user.service';
import { PushNotificationService } from './shared/push-notification.service';
import { AssetCardComponent } from 'src/app/shared/components/asset-card/asset-card.component';
import { SharedModule } from 'src/app/shared/components/shared.modules';
import { UserProfileComponent } from './components/profile/user-profile/user-profile.component';
import { AuditComponent } from './components/profile/audit/audit.component';
import { PipeModule } from 'src/app/shared/pipe/pipe.module';
import { AdministrationComponent } from './components/profile/administration-page/administration-page.component';
import { UserActivityComponent } from './components/profile/user-activity/user-activity.component';
import { ManageuserComponent } from './components/profile/manageuser/manageuser.component';
import { ManageFolderStructureComponent } from './components/profile/manage-folder-structure/manage-folder-structure.component';
// import { ProductStatusPipe } from './Shared/pipe/product-status.pipe';
// import { ProfileComponent } from './profile/profile.component';
import {ApiDocumentationComponent} from './components/api-documentation/api-documentation.component';
import { FaqComponent } from './faq/faq.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { ManagegroupComponent } from './components/profile/managegroup/managegroup.component';
import { DashboardComponent } from './components/dashboard/components/dashboard.component';

let components = [
  ProfileComponent,
  SettingsComponent,
  UserProfileComponent,
  AuditComponent,
  UserActivityComponent,
  ManageuserComponent,
  ManageFolderStructureComponent,
  ApiDocumentationComponent,
  FaqComponent,
  TermsAndConditionsComponent,
  ManagegroupComponent,
  DashboardComponent
];

@NgModule({
  declarations: components,
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    PipeModule
  ],
  providers: [UserService, PushNotificationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: components
})
export class UserModule { }
